import React, { useEffect, useState } from "react";
import { Form, Button, Input, message, Select, Modal } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { apiClient } from "../Api/AllApi";

import "../Styles/AddProducts.css";
const AddProducts = () => {
  const [form1] = Form.useForm();
  const { t, i18n } = useTranslation();
  const [nameKurdish, setNameKurdish] = useState("");
  const [nameArabic, setNameArabic] = useState("");
  const [unit, setUnit] = useState(null);
  const [price, setPrice] = useState(0);
  const [image_url, setImage_url] = useState(null);
  const [stock, setStock] = useState(0);
  const [sku, setSku] = useState(0);
  const [weight, setWeight] = useState(0); // Add new state for weight
  // Add new state variables for subunits
  const [storeSubUnits, setStoreSubUnits] = useState([]);
  const [selectedSubUnit, setSelectedSubUnit] = useState(null);
  const [subUnitRatio, setSubUnitRatio] = useState(1);
  const [subUnitPrice, setSubUnitPrice] = useState(0);
  //todo this is Modal  Name
  const [isModalOpenNew, setIsModalOpenNew] = useState(false);

  const handleCancelNew = () => {
    setIsModalOpenNew(false);
  };
  const showModalNew = () => {
    setIsModalOpenNew(true);
  };

  const handleOkNew = () => {
    setIsModalOpenNew(false);
  };
  //! End modal  //TODO: GET units and categories
  const [storeUnits, setStoreUnits] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  // Fetch units and categories
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [unitsResponse, categoriesResponse] = await Promise.all([
          apiClient.get(`/units`),
          apiClient.get('/categories')
        ]);

        // Handle units response
        setStoreUnits(unitsResponse.data);

        // Handle categories response
        const categoriesData = categoriesResponse.data.map(category => {
          try {
            const nameObj = JSON.parse(category.name);
            // Get the name in the current language with fallbacks
            const displayName = nameObj[i18n.language] || nameObj.en || nameObj.ar || "Unknown";
            return {
              id: category.id,
              name: displayName,
              fullNameObj: nameObj,
              status: category.status
            };
          } catch (error) {
            console.error("Error parsing category name for id " + category.id + ":", error);
            return {
              id: category.id,
              name: "Error parsing name",
              status: category.status
            };
          }
        });

        setCategories(categoriesData);
      } catch (error) {
        console.error("Error fetching data:", error);
        message.error(t("Failed to fetch categories or units"));
      }
    };

    fetchData();
  }, [i18n.language]);
  //TODO: Post Products
  const PostApi = async () => {
    try {
      // Validate required fields
      if (!unit) {
        message.error(t("Please select a unit"));
        return;
      }      // Create a regular object - don't use FormData for this API
      const productData = {
        unit_id: unit,
        name: JSON.stringify({
          en: nameKurdish,
          ar: nameArabic,
        }),
        price: price,
        sku: sku || '0', // Ensure sku is sent and not empty
        stock: stock || 0,
        weight: weight || 0, // Add weight to product data
      };

      // Add category_id if selected
      if (selectedCategory) {
        productData.category_id = selectedCategory;
      }

      // Add image_url if it exists
      if (image_url) {
        productData.image_url = image_url;
      }

      // Add subunit data if selected
      if (selectedSubUnit) {
        productData.sub_unit_id = selectedSubUnit;
        productData.sub_unit_ratio = subUnitRatio || 1;
        productData.sub_unit_price = subUnitPrice || 0;
      }


      // Use apiClient.post properly
      const response = await apiClient.post('/products', productData);

      // Handle success
      message.success(t("Form submitted successfully"));

      // Optionally, redirect after successful submission
      window.location.href = "/GetProducts";
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        // Log detailed error information
        console.error("Error response:", error.response.data);
        message.error(`${t("Failed to submit form")}: ${error.response.data.message || error.message}`);
      } else {
        message.error(t("Failed to submit form. Please try again later."));
      }
    }
  };
  //todo ---------------------------------------------------------------------
  const onFinish = (values) => {
    // console.log("Success:", values);
    // message.success("Success Post ");
  };
  const onFinishFailed = (errorInfo) => {
    // console.log("Failed:", errorInfo);
    message.error("Error");
  }; const handleResetCart = () => {
    form1.resetFields();
    // Reset all state variables to their initial values
    setNameKurdish("");
    setNameArabic("");
    setUnit(null);
    setPrice(0);
    setImage_url(null);
    setStock(0);
    setSku(0);
    setWeight(0);
    setStoreSubUnits([]);
    setSelectedSubUnit(null);
    setSubUnitRatio(1);
    setSubUnitPrice(0);
    setImagePreviewUrl(null);
  };
  //todo  -----------------------------------------------
  //todo  ----------------------------------------------
  //todo this is Image========================================
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const handleImageChange = async (file) => {
    // Generate a preview URL for the image file
    const previewUrl = URL.createObjectURL(file);
    setImagePreviewUrl(previewUrl);

    // Proceed with the upload logic
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await apiClient.post(
        "/upload-file",
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.status === 200) {
        const imageUrl = response.data.path;
        setImage_url(imageUrl);
        // message.success("Image uploaded successfully");

        // Revoke the preview URL after upload is successful
        URL.revokeObjectURL(previewUrl);
      } else {
        message.error("Failed to upload image");
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      message.error("Failed to upload image");
      URL.revokeObjectURL(previewUrl);
    }
  };
  const normFile = (e) => {
    return e && e.fileList ? [e.file] : [];
  };
  const onChangeUpload = async (e) => {
    if (e && e.target && e.target.files) {
      const file = e.target.files[0];
      await handleImageChange(file);
    }
  };
  //todo  -----------------------------------------------
  const layout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 16,
    },
  }; const handleUnitChange = async (value) => {
    setUnit(value);

    // Reset subunit-related states when the main unit changes
    setSelectedSubUnit(null);
    setSubUnitRatio(1);
    setSubUnitPrice(0);
    setStoreSubUnits([]);

    // Only fetch subunits if a unit is selected
    if (value) {
      try {
        const response = await apiClient.get("/units/" + value + "/sub");
        setStoreSubUnits(response.data || []);
      } catch (error) {
        console.error("Error fetching subunits:", error);
        setStoreSubUnits([]);
      }
    }
  }; const handleSubUnitChange = (value) => {
    setSelectedSubUnit(value);

    const sub = storeSubUnits.find((s) => s.id === value);

    if (sub && sub.ratio) {
      const ratio = Number(sub.ratio) || 1;
      setSubUnitRatio(ratio);
      if (price) {
        const calculatedPrice = Number(price) / ratio;
        setSubUnitPrice(calculatedPrice);
      }
    } else {
      setSubUnitRatio(1);
      setSubUnitPrice(Number(price) || 0);
    }
  };
  // Update subunit price when main price changes
  useEffect(() => {
    if (selectedSubUnit && price && subUnitRatio) {
      setSubUnitPrice(Number(price) / Number(subUnitRatio));
    }
  }, [price, subUnitRatio, selectedSubUnit]);

  // Update subunit price when ratio changes
  useEffect(() => {
    if (selectedSubUnit && price && subUnitRatio > 0) {
      setSubUnitPrice(Number(price) / Number(subUnitRatio));
    }
  }, [subUnitRatio, price, selectedSubUnit]);

  return (
    <div style={{ textAlign: "center", marginTop: "50px", direction: "rtl" }}>
      <h1 style={{ fontSize: "24px", marginBottom: "20px" }}>
        {t("add products")}{" "}
      </h1>
      <Form
        form={form1}
        {...layout}
        style={{
          fontSize: "18px", // Global font size for the entire form
        }}
        labelCol={{ span: 6 }} // Adjusts label width
        wrapperCol={{ span: 16 }} // Adjusts input width
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        {/* //todo this is image  */}
        <div className="centered-form-item">
          <Form.Item
            name="image-url"
            // label={"image"}
            valuePropName="fileList"
            getValueFromEvent={normFile}
            rules={[
              {
                type: "text",
                required: false,
                message: "Image is invalid",
              },
            ]}
          >
            <input
              id="single-image-upload"
              type="file"
              style={{ display: "none" }}
              onChange={onChangeUpload}
            />
            <label htmlFor="single-image-upload">
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="span"
                className="upload-button"
              >
                {t("image")}
              </IconButton>
            </label>
            {imagePreviewUrl ? (
              <img
                src={imagePreviewUrl}
                alt="Preview of the selected file"
                className="image-preview"
              />
            ) : image_url ? (
              <img
                src={image_url}
                alt="Uploaded file preview"
                className="image-preview"
              />
            ) : null}
          </Form.Item>
        </div>
        {/* //TODO: name products ============== */}
        <Form.Item name="name" label={t("name")}>
          <Button
            type="text"
            style={{
              border: "1px solid #ccc",
              borderRadius: "4px",
              width: "70%",
              fontSize: "16px",
              textAlign: "center",
              display: "inline-block",

              backgroundColor: "#f0f0f0", // Change background color
              color: "#333", // Change text color
              fontWeight: "bold", // Make text bold
              boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.1)", // Add a box shadow
            }}
            onClick={showModalNew}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {t("enter name product")}
              <DownOutlined />
            </div>
          </Button>

          <Modal
            style={{
              direction: "rtl",
            }}
            title={t("enter name product")}
            open={isModalOpenNew}
            onOk={handleOkNew}
            onCancel={handleCancelNew}
          >
            <Form
              form={form1}
              // onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{ remember: true }}
            >
              <Form.Item
                name="kurdish"
                label={t("كوردى")}
                value={nameKurdish}
                onChange={(e) => setNameKurdish(e.target.value)}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="arabic"
                label={t("عربي")}
                value={nameArabic}
                onChange={(e) => setNameArabic(e.target.value)}
              >
                <Input />
              </Form.Item>
            </Form>
          </Modal>        </Form.Item>          {/* Category Selection */}
        <Form.Item 
          name="category_id" 
          label={t("Category")}
        >
          <Select
            style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
            placeholder={t("Select category")}
            allowClear
            onChange={(value) => setSelectedCategory(value)}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {categories.length > 0 ? (
              categories.map(category => (
                <Select.Option key={category.id} value={category.id}>
                  {category.name}
                </Select.Option>
              ))
            ) : (
              <Select.Option disabled>{t("No categories available")}</Select.Option>
            )}
          </Select>
        </Form.Item>

        {/* //! end image ================================= */}

        <Form.Item
          name="Price"
          label={
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>
              {t("price")}
            </span>
          }
        >
          <Input
            style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
            placeholder={t("أدخل السعر")}
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
        </Form.Item>        <Form.Item
          label={
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>
              {t("unit")}
            </span>
          }
          name="units"
        // rules={[{ required: true, message: "Please input your units" }]}
        >
          <Select
            placeholder={t("حدد الوحدة")}
            style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
            value={unit}
            onChange={handleUnitChange}
            allowClear
          >
            {storeUnits.map((unitItem) => {
              let unitName = '';
              try {
                if (unitItem.name && typeof unitItem.name === 'string') {
                  const parsedName = JSON.parse(unitItem.name);
                  unitName = parsedName.en || parsedName.ar || unitItem.name;
                } else {
                  unitName = unitItem.name || `Unit ${unitItem.id}`;
                }
              } catch (error) {
                console.error('Error parsing unit name:', error);
                unitName = unitItem.name || `Unit ${unitItem.id}`;
              }

              return (
                <Select.Option key={unitItem.id} value={unitItem.id}>
                  {unitName}
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.Item
          name="sku"
          label={
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>
              {t("sku")}
            </span>
          }
        >
          <Input
            style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
            placeholder={t("أدخل رقم SKU الخاص بك")}
            value={sku}
            onChange={(e) => setSku(e.target.value)}
          />
        </Form.Item>

        <Form.Item
          name="stock"
          label={
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>
              {t("stock")}
            </span>
          }
        >
          <Input
            style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
            placeholder={t("أدخل المخزون")}
            value={stock}
            onChange={(e) => setStock(e.target.value)}
          />
        </Form.Item>        <Form.Item
          name="weight"
          label={
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>
              {t("کێش")}
            </span>
          }
        >
          <Input
            type="number"
            style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
            placeholder={t("کێش بە کیلۆگرام داخڵ بکە")}
            value={weight}
            onChange={(e) => setWeight(e.target.value)}
            suffix="KG"
            min="0"
            step="0.01"
          />
        </Form.Item>
        {/* Subunit Selector */}

        {storeSubUnits.length > 0 && (
          <Form.Item
            label={t("یەکەی ژێر")}
            name="sub_unit_id"
          >
            <Select
              placeholder={t("Select sub unit")}
              style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
              value={selectedSubUnit ? { value: selectedSubUnit, label: storeSubUnits.find((s) => s.id === selectedSubUnit)?.name || selectedSubUnit } : null}
              onChange={(value) => {
                setSelectedSubUnit(value.value);
                handleSubUnitChange(value.value);
              }}
              labelInValue
              allowClear
            >              {storeSubUnits.map((sub) => {
              let subUnitName = '';
              try {
                if (sub.name && typeof sub.name === 'string') {
                  const parsedName = JSON.parse(sub.name);
                  subUnitName = parsedName.en || parsedName.ar || parsedName.ku || sub.name;
                } else if (typeof sub.name === 'object') {
                  subUnitName = sub.name.en || sub.name.ar || sub.name.ku || String(sub.name);
                } else {
                  subUnitName = String(sub.name);
                }
              } catch (error) {
                console.error('Error parsing sub unit name:', error);
                subUnitName = sub.name || `Sub Unit ${sub.id}`;
              }

              return (
                <Select.Option key={sub.id} value={sub.id} label={subUnitName}>
                  {subUnitName}
                </Select.Option>
              );
            })}
            </Select>
          </Form.Item>
        )}

        {/* Ratio */}
        {selectedSubUnit && (
          <Form.Item
            label={t("پێوانەی یەکە")}
            name="sub_unit_ratio"
            rules={[{ required: true, message: t("Please enter sub unit ratio") }]}
          >
            <Input
              style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
              value={subUnitRatio}
              onChange={(e) => {
                const value = Number(e.target.value);
                if (value > 0) {
                  setSubUnitRatio(value);
                  // Update subunit price when ratio changes
                  if (price) {
                    setSubUnitPrice(Number(price) / value);
                  }
                }
              }}
            />
          </Form.Item>
        )}

        {/* Price per subunit */}
        {selectedSubUnit && (
          <Form.Item
            label={t("نرخی یەک ژێر یەکە")}
            name="sub_unit_price"
          >
            <Input
              style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
              value={subUnitPrice}
              onChange={(e) => setSubUnitPrice(e.target.value)}
            />
          </Form.Item>
        )}
        {/* <Form.Item>
          <Checkbox checked={pinned} onChange={onChangeCheckbox}>
            Add Slider
          </Checkbox>
        </Form.Item> */}
        <Form.Item label=".">
          <Button
            type="primary"
            htmlType="submit"
            onClick={PostApi}
            style={{
              backgroundColor: "green",
              borderColor: "green",
              fontSize: "16px",
            }}
          >
            {t("submit")}
          </Button>
          <span style={{ margin: "0 8px" }}></span>
          <Button
            type="primary"
            danger
            onClick={handleResetCart}
            style={{
              backgroundColor: "blue",
              borderColor: "blue",
              fontSize: "16px",
            }}
          >
            {t("reset")}
          </Button>
          <span style={{ margin: "0 8px" }}></span>
          <Button
            type="primary"
            style={{
              backgroundColor: "red",
              borderColor: "red",
              fontSize: "16px",
            }}
            danger
            onClick={() => (window.location.href = "/GetProducts")}
          >
            {t("cancel")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AddProducts;